const HeaderDescWithPhoto = {};

export default HeaderDescWithPhoto